"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchHighlight = void 0;
const searchHighlight = () => {
    let referrer = document.referrer;
    let textNodes;
    let isSearchPage = document.querySelector('[data-search="true"]');
    if (referrer.includes('?s') && !isSearchPage) {
        let query = referrer.replace(referrer.split('/?s=').shift() + '/?s=', '');
        if (query === '') {
            return;
        }
        let queryRegex = new RegExp(query, "ig");
        function textNodesUnder(node) {
            let all = [];
            for (node = node.firstChild; node; node = node.nextSibling) {
                if (node.nodeType == 3)
                    all.push(node);
                else
                    all = all.concat(textNodesUnder(node));
            }
            return all;
        }
        textNodes = textNodesUnder(document.querySelector('[data-highlight="search"]'));
        for (let i in textNodes) {
            let textContent = textNodes[i].textContent;
            if (textContent.toLowerCase().includes(query)) {
                let textContentStart = textContent.split(queryRegex).shift();
                let textContentEnd = textContent.split(queryRegex).pop();
                let strong = document.createElement('span');
                strong.classList.add('search-highlight');
                strong.innerHTML = textContent.match(queryRegex)[0];
                textNodes[i].textContent = textContentStart;
                textNodes[i].after(strong);
                textNodes[i].nextSibling.after(textContentEnd);
            }
        }
    }
};
exports.searchHighlight = searchHighlight;
